/**
 * Normalise une URL d'image afin de tolérer les anciens formats stockés en base.
 *
 * Corrige notamment :
 *  - le double préfixe accidentel `/api/api/`  → `/api/`
 *  - l'ancien chemin backend `/api/images/`    → `/api/uploads/`
 *  - le chemin nu `/uploads/` (sans `/api`)    → `/api/uploads/`
 *
 * Les data URIs (`data:`) et les chemins statiques du frontend (`/images/...`,
 * sans `/api`) sont laissés intacts. Les URLs externes (https://autre-domaine)
 * ne sont pas altérées, hormis la correction du double `/api/api/`.
 *
 * @param raw URL brute (peut être null/undefined)
 * @returns URL normalisée, ou chaîne vide si l'entrée est vide
 */
export function normalizeImageUrl(raw?: string | null): string {
  if (!raw) return '';
  let url = String(raw).trim();
  if (!url) return '';

  // Les images embarquées (base64) sont retournées telles quelles.
  if (url.startsWith('data:')) return url;

  // Double préfixe API accidentel (peut apparaître n'importe où dans l'URL).
  url = url.replace(/\/api\/api\//gi, '/api/');

  // Ancien chemin backend des médias → chemin servi réellement.
  url = url.replace(/\/api\/images\//gi, '/api/uploads/');

  // Chemin d'upload nu (sans le préfixe /api) en début d'URL relative.
  url = url.replace(/^\/uploads\//i, '/api/uploads/');

  return url;
}

export default normalizeImageUrl;
